<template>
    <div class="videoPool">
      <div style="padding: 2rem"></div>
      <div v-if="showSearchBar" class="video-searchbar">
          <div style="width: 100%; align-self: center;">
            <input style="width:100%; height: 2.5rem" v-model="search_word">
          </div>
          <md-button class="md-icon-button md-primary"><md-icon>search</md-icon></md-button>
      </div>
      <div v-if="showFilter" class="video-filter">
        <div style="font-weight: 600; margin-right: 1rem;">分類:</div> <!-- 年級->科目->題目->資源類型-->
        <select id="year_selected" v-model="year">
            <option selected value='所有'>所有年級</option>
            <option v-for="folder in years" :value="folder.info.title" :key="folder.info.id">{{ folder.info.title }}</option>
        </select>
        <!-- <div><eva-icon name="arrow-right" fill="#397f1f"/></div> -->
        <select id="subject_selected" v-model="subject">
            <option selected value='所有'>所有科目</option>
            <option v-for="folder in subjects" :value="folder.info.title" :key="folder.info.id">{{ folder.info.title }}</option>
        </select>
      </div>
      <div class="videocells" id="play_window" style="margin-top: 1rem">
        <h4 v-if="show_file_list.filter(f=>f.show).length === 0" style="margin-right: auto; margin-left: auto;">{{emptyString}}</h4>
        <VideoCell v-for="file in fileCache" :key="file.info.id" :file="file" :actions="actions" :buttons="buttons" v-show="file.show"/>
      </div>
      <el-pagination
        layout="prev, pager, next"
        :current-page.sync="currPage"
        :total="total"
        :page-size="pageSize">
      </el-pagination>
    </div>
</template>

<style lang="scss" scoped>
  @import "~vue-material/dist/theme/engine";

  @include md-register-theme("default", (
    primary:#397f1f, // The accent or secondary colortheme: dark // This can be dark or light
  ));

  @import "~vue-material/dist/theme/all";
  .videoPool{
      max-width: 800px;
      margin: 2rem auto;
      padding: 0 2rem;
  }
  .videocells{
    display: flex;
    flex-wrap: wrap;
  }

  .video-label{
    flex: 0 0 100px;
    margin: 1rem 0;
  }

  input{
      border:none;
      background-image:none;
      background-color:transparent;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
  }
  input:focus{
      outline: none;
      border:none;
      background-image:none;
      background-color:transparent;
      -webkit-box-shadow: none;
      -moz-box-shadow: none;
      box-shadow: none;
  }

  .video-searchbar{
    border-radius: 1rem;
    display: flex;
    box-shadow: 0 0 3px 0px #397f1f;
    padding-left: 0.5rem;
  }
  select{
    font-size: 1.5rem;
    color: #397f1f;
    outline-color: #397f1f;
    border-color: #397f1f;
    border-radius: 1.5rem;
    padding: 0 1rem;
    width: 10rem;
  }
  select:focus{
    outline: none;
  }
  .video-filter{
    display: flex;
    flex-wrap: wrap;
    font-size: 1.5rem;
  }
  .video-filter > *{
    margin-top: 10px;
  }
  .video-filter div{
    align-self: center;
  }
</style>

<script>

import { EvaIcon } from 'vue-eva-icons'
import VideoCell from '@/components/Video/VideoCell'
let fuzzySearch = function (list, word, key) {
  if (key === undefined) {
    key = x => x
  }
  let pattern = RegExp(word.trim().split('').join('.*'))
  return list.map(file => {
    file.textShow = file.info.name.search(pattern) > -1 || file.info.description.search(pattern) > -1
    return file
  }).filter(file => file.textShow)
}
let getChild = function (parent, catagories) {
  catagories = catagories || []
  if (parent.sub_folders === undefined) {
    parent.catagories = catagories
    // parent.show = true
    return parent
  }
  return parent.sub_folders.reduce((acc, cur) => {
    return acc.concat(getChild(cur, parent.info !== undefined ? catagories.concat(parent.info.title) : catagories))
  }, [])
}
export default {
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    buttons: {
      type: Object,
      default: () => ({
        like: true,
        bookmark: true,
        download: false
      })
    },
    folders: {
      type: Array,
      default: () => []
    },
    showSearchBar: {
      type: Boolean,
      default: true
    },
    showFilter: {
      type: Boolean,
      default: true
    },
    typeFilter: {
      type: Function,
      default: () => true
    },
    pageSize: {
      type: Number,
      default: 10
    },
    emptyString: {
      type: String,
      default: '沒有影片'
    }
  },
  components: {
    VideoCell, [EvaIcon.name]: EvaIcon
  },
  data () {
    return {
      years: [
        {
          info: {
            id: 'y1',
            title: '中一'
          }
        },
        {
          info: {
            id: 'y2',
            title: '中二'
          }
        },
        {
          info: {
            id: 'y3',
            title: '中三'
          }
        }
      ],
      subjects: [
        {
          info: {
            id: 's1',
            title: '數學'
          }
        },
        {
          info: {
            id: 's2',
            title: '英文'
          }
        }
      ],
      year: '所有',
      subject: '所有',
      search_word: '',
      currPage: 1,
      fileCache: []
    }
  },
  computed: {
    file_list: function () {
      let files = getChild(this.rootFolder)
      // filter out non video type resource since UI can just show video only so far
      files = files.filter(this.typeFilter)
      return files
    },
    rootFolder: function () {
      let root = {
        sub_folders: this.folders
      }
      return root
    },
    show_file_list: function () {
      let fileList = fuzzySearch(this.file_list, this.search_word, file => file.info.name)
      fileList = fileList.map(file => {
        file.isMatched = file.textShow && (this.subject === '所有' || file.catagories.includes(this.subject)) && (this.subject === '英文' || this.year === '所有' || file.catagories.includes(this.year))
        return file
      }).filter(file => file.isMatched)
      let start = (this.currPage - 1) * this.pageSize
      let end = start + this.pageSize
      let count = 0
      fileList = fileList.map(file => {
        file.show = start <= count && count < end
        count += 1
        return file
      })
      return fileList
    },
    total: function () {
      return this.show_file_list.length
    }
  },
  watch: {
    // years: function (newYears) {
    //   let disabled = newYears === undefined || newYears.length === 0
    //   document.getElementById('year_selected').disabled = disabled

    //   if (disabled) {
    //     this.year = ''
    //   }
    // },
    year: function (newYearId) {
      let year = this.years.find(x => x.info.id === newYearId)
      if (year !== undefined) {
        this.subjects = year.sub_folders
        this.subject = -1
      }
    },
    // subjects: function (newSubjects) {
    //   let disabled = newSubjects === undefined || newSubjects.length === 0
    //   document.getElementById('subject_selected').disabled = disabled

    //   if (disabled) {
    //     this.subject = -1
    //   }
    // },
    subject: function (newSubjectId) {
      // this.rootFolder = this.subjects.find(x => x.info.id === newSubjectId)
      // if (newSubjectId === -1) {
      //   this.file_list = []
      // } else {
      //   this.file_list = this.subjects.find(x => x.info.id === newSubjectId).sub_folders
      //   this.file_list.map(file => {
      //     file.parent_id = newSubjectId
      //     return file
      //   })
      // }
    },
    show_file_list: function (fileList) {
      this.fileCache.forEach(file => {
        file.isMatched = false
        file.show = false
      })
      fileList.filter(file => file.show).forEach(file => {
        let index = this.fileCache.findIndex(_file => _file.info.id === file.info.id)
        if (index > -1) {
          let targetFile = this.fileCache[index]
          targetFile.isMatched = true
          targetFile.show = true
        } else {
          this.fileCache.push(Object.assign({}, file))
        }
      })
      return this.fileCache
    },
    file_list: function () {
      console.log('have new file_list')
    },
    mounted () {
      console.log('mount')
    },
    beforeUpdate () {
      console.log('beforeUpdate')
    },
    updated () {
      console.log('updated')
    },
    activated () {
      console.log('activated')
    },
    deactivated () {
      console.log('deactivated')
    },
    beforeDestroy () {
      console.log('beforeDestroy')
    },
    destroyed () {
      console.log('destroyed')
    }
  }
}
</script>
